import { BACKEND_URL } from '../config';

/** Récupère le hashPass legacy pour le serveur Java (comptes OAuth inclus). */
export async function fetchGameHashPass(token: string): Promise<string | null> {
  try {
    const res = await fetch(`${BACKEND_URL}/api/auth/game-hash`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.hashPass || null;
  } catch {
    return null;
  }
}
